import ScaleIcon from "@redotech/redo-icons/scales-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.usedWeightLearning;

export const UsedWeightLearningFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: ScaleIcon,
  displayName: entry.displayName,
  label: "Weight learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
